import { render } from "./AdminExperience.vue?vue&type=template&id=d87daa94"
import script from "./AdminExperience.vue?vue&type=script&lang=js"
export * from "./AdminExperience.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__